<script setup lang="ts">
import { ROUTE_NAMES } from '~/constants/routes';
import { isAuction, type PlatformSaleItemEntity } from '~/types/sale.type';

// PROPS
interface Props {
    sale: PlatformSaleItemEntity;
}

const { sale } = defineProps<Props>();

// COMPOSABLES
const { tt } = useTypedI18n();
const route = useRoute();
const localePath = useLocalePath();
const { trackNegotiationGoToNegotiation } = useTracking();

// DATA
const isBuyer = computed(() => !sale.canActForSellerCompany);

const label = computed(() => tt(isAuction(sale) || isBuyer.value ? 'negotiation.goToNegotiation' : 'negotiation.showNegotiations'));

const routeTo = computed(() => ({
    name: isAuction(sale) ? ROUTE_NAMES.AUCTION_DETAIL_NEGOTIATION : ROUTE_NAMES.DIRECT_SALE_DETAIL_NEGOTIATION,
    params: route.params,
}));

// METHODS
const onClick = (): void => {
    trackNegotiationGoToNegotiation(isAuction(sale) || isBuyer.value ? 'go_negotiation' : 'show_negotiation');
};
</script>

<template>
    <UButton
        size="lg"
        color="neutral"
        variant="outline"
        :ui="buttonResponsiveSizeUi('lg', 'xl')"
        :label="label"
        block
        :to="localePath(routeTo)"
        @click="onClick"
    />
</template>
